import { render, staticRenderFns } from "./BusinessFinancials.vue?vue&type=template&id=6bea5aff&scoped=true"
import script from "./BusinessFinancials.vue?vue&type=script&lang=js"
export * from "./BusinessFinancials.vue?vue&type=script&lang=js"
import style0 from "./BusinessFinancials.vue?vue&type=style&index=0&id=6bea5aff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bea5aff",
  null
  
)

export default component.exports